// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mio-access {
  display: flex;
  height: 100%;
  position: relative;
}
.mio-access .section {
  flex: 1;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.1);
  overflow: auto;
  position: relative;
}
.mio-access .section__inner {
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  bottom: 0;
}
.mio-access .section-row {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c5c5c5;
  padding: 10px;
  cursor: pointer;
}
.mio-access .section-row .title,
.mio-access .section-row .jk,
.mio-access .section-row .oper {
  display: flex;
  align-items: center;
}
.mio-access .section-row .jk,
.mio-access .section-row .oper {
  text-align: center;
}
.mio-access .section-row .title {
  width: 60%;
}
.mio-access .section-row .jk {
  width: 25%;
  justify-content: center;
}
.mio-access .section-row .oper {
  width: 15%;
  justify-content: center;
}
.mio-access .section-row .oper.btnDisable {
  color: #c5c5c5;
  cursor: default;
}
.mio-access .section-row:hover, .mio-access .section-row.active {
  background: rgba(0, 0, 0, 0.3);
  color: #ffffff;
}
.mio-access .section-row.last {
  border-radius: 0 0 5px 5px;
}
.mio-access .section-row.header {
  height: 40px;
  font-size: 13px;
  font-weight: bold;
  cursor: default;
  position: sticky;
  top: 0;
  background: #CECECE;
  z-index: 1;
}
.mio-access .section-row.header:hover {
  background: #CECECE;
  color: #000000;
}
.mio-access .section-row.no-hover:hover {
  background: none;
  color: #000000;
}
.mio-access .section:nth-child(1) {
  margin: 0;
}
.mio-access .section.spots {
  flex: 2;
}

.close {
  cursor: pointer;
  position: absolute;
  top: -24px;
  right: -16px;
  font-size: 20px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/mio/mio-access-dialog/mio-access-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,YAAA;EACA,kBAAA;AACJ;AAAI;EACI,OAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,8BAAA;EACA,cAAA;EACA,kBAAA;AAER;AADQ;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AAGZ;AADQ;EACI,aAAA;EACA,8BAAA;EACA,gCAAA;EACA,aAAA;EACA,eAAA;AAGZ;AAFY;;;EAGI,aAAA;EACA,mBAAA;AAIhB;AAFY;;EAEI,kBAAA;AAIhB;AAFY;EACI,UAAA;AAIhB;AAFY;EACI,UAAA;EACA,uBAAA;AAIhB;AAFY;EACI,UAAA;EACA,uBAAA;AAIhB;AAHgB;EACI,cAAA;EACA,eAAA;AAKpB;AAFY;EAEI,8BAAA;EACA,cAAA;AAGhB;AADY;EACI,0BAAA;AAGhB;AADY;EACI,YAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,MAAA;EACA,mBAAA;EACA,UAAA;AAGhB;AAFgB;EACI,mBAAA;EACA,cAAA;AAIpB;AAAgB;EACI,gBAAA;EACA,cAAA;AAEpB;AAEQ;EACI,SAAA;AAAZ;AAEQ;EACI,OAAA;AAAZ;;AAKA;EACI,eAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAFJ","sourcesContent":[".mio-access {\r\n    display: flex;\r\n    height: 100%;\r\n    position: relative;\r\n    .section {\r\n        flex: 1;\r\n        margin-left: 10px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        border-radius: 5px;\r\n        background: rgba(0, 0, 0, 0.1);\r\n        overflow: auto;\r\n        position: relative;\r\n        &__inner {\r\n            position: absolute;\r\n            top: 40px;\r\n            left: 0;\r\n            right: 0;\r\n            bottom: 0;\r\n        }\r\n        &-row {\r\n            display: flex;\r\n            justify-content: space-between;\r\n            border-bottom: 1px solid #c5c5c5;\r\n            padding: 10px;\r\n            cursor: pointer;\r\n            .title,\r\n            .jk,\r\n            .oper {\r\n                display: flex;\r\n                align-items: center;\r\n            }\r\n            .jk,\r\n            .oper {\r\n                text-align: center;\r\n            }\r\n            .title {\r\n                width: 60%;\r\n            }\r\n            .jk {\r\n                width: 25%;\r\n                justify-content: center;\r\n            }\r\n            .oper {\r\n                width: 15%;\r\n                justify-content: center;\r\n                &.btnDisable {\r\n                    color: #c5c5c5;\r\n                    cursor: default;\r\n                }\r\n            }\r\n            &:hover,\r\n            &.active {\r\n                background: rgba(0, 0, 0, 0.3);\r\n                color: #ffffff;\r\n            }\r\n            &.last {\r\n                border-radius: 0 0 5px 5px;\r\n            }\r\n            &.header {\r\n                height: 40px;\r\n                font-size: 13px;\r\n                font-weight: bold;\r\n                cursor: default;\r\n                position: sticky;\r\n                top: 0;\r\n                background: #CECECE;\r\n                z-index: 1;\r\n                &:hover {\r\n                    background: #CECECE;\r\n                    color: #000000;\r\n                }\r\n            }\r\n            &.no-hover {\r\n                &:hover {\r\n                    background: none;\r\n                    color: #000000;\r\n                }\r\n            }\r\n        }\r\n        &:nth-child(1) {\r\n            margin: 0;\r\n        }\r\n        &.spots {\r\n            flex: 2;\r\n        }\r\n    }\r\n}\r\n\r\n.close {\r\n    cursor: pointer;\r\n    position: absolute;\r\n    top: -24px;\r\n    right: -16px;\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
